module.exports = __webpack_public_path__ + "img/ico_dm_1.5eaa12a6.png";